import React from 'react'

import { Box, Checkbox, RadioButton } from '@factorialco/deprecated-design-system'

import { Element } from 'modules/forms/lib/Element'

interface OptionElementPreviewProps {
  element: Element
  isSingleChoice: boolean
  disabled?: boolean
}

export const OptionElementPreview: React.FC<OptionElementPreviewProps> = ({
  element,
  isSingleChoice,
  disabled,
}) => {
  const Component = isSingleChoice ? RadioButton : Checkbox

  return (
    <>
      {element.options.map((option, index) => {
        const optionValue = option.id || `${element.uuid}-${index}`
        const isCorrect = option.isCorrect

        return (
          <Box key={optionValue} borderRadius={{ all: 'abs012' }} padding="s12">
            <Component
              size="small"
              value={optionValue}
              label={option.label}
              disabled={disabled}
              checked={isCorrect}
              onChange={() => {}}
            />
          </Box>
        )
      })}
    </>
  )
}
